export default [
  {
    path: '/admin/logs',
    name: 'indexLogsAdmin',
    meta: { title: 'indexLogsAdmin' },
    component: () => import('@/pages/admin/logs'),
  },
]
